var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIeRatioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6CB8C7;stroke-width:12.1776;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#6CB8C7;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#6CB8C7;}\n\t.st3{fill:#FFFFFF;stroke:#6CB8C7;stroke-width:20;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#6CB8C7;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#6CB8C7;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:17.5833;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#6CB8C7;stroke-width:22.8092;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#6CB8C7;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#FFFFFF;stroke:#6CB8C7;stroke-width:18.6;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.6,172.3c0,4.5,3.6,8.1,8.1,8.1h190.3c31,0,56.2-25.2,56.2-56.2c0-30.8-25-55.9-55.7-56.2 c-0.1,0-0.1,0-0.2,0h-0.3c-0.1,0-0.1,0-0.2,0c-21.7,0.3-39.3,18-39.3,39.8c0,21.9,17.9,39.8,39.8,39.8c4.5,0,8.1-3.6,8.1-8.1 s-3.6-8.1-8.1-8.1c-13,0-23.6-10.6-23.6-23.6c0-13,10.5-23.5,23.5-23.6c22,0.1,39.8,18,39.8,40c0,22-17.9,40-40,40H70.7 C66.3,164.2,62.6,167.8,62.6,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.2,226.8H154.4c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1h116.8c11.8,0,21.4,9.6,21.4,21.4 c0,11.8-9.5,21.3-21.3,21.4c-6.2,0-11.3-5.1-11.3-11.4c0-4.4,2.6-8.5,6.6-10.3c4.1-1.9,5.8-6.7,3.9-10.7c-1.9-4.1-6.7-5.8-10.7-3.9 c-9.7,4.5-16,14.3-16,25c0,15.1,12.2,27.3,27.2,27.5c0.1,0,0.1,0,0.2,0h0.2c0,0,0.1,0,0.1,0c20.6-0.2,37.3-17,37.3-37.6 C308.8,243.6,291.9,226.8,271.2,226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,210.6h191.7c4.5,0,8.1-3.6,8.1-8.1c0-4.5-3.6-8.1-8.1-8.1H37.5c-4.5,0-8.1,3.6-8.1,8.1 C29.4,207,33,210.6,37.5,210.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.4,112.9c0-7.1-5.8-12.9-12.9-12.9c-7.1,0-12.9,5.8-12.9,12.9c0,7.1,5.8,12.9,12.9,12.9 C168.6,125.8,174.4,120,174.4,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.1,268.6c-7.1,0-12.9,5.8-12.9,12.9c0,7.1,5.8,12.9,12.9,12.9c7.1,0,12.9-5.8,12.9-12.9 C217,274.4,211.3,268.6,204.1,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.1,70.6c0-5.5-4.5-10-10-10c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10C137.7,80.6,142.1,76.1,142.1,70.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.451023e-02 -0.9955 0.9955 9.451023e-02 96.2933 491.4195)",
    className: "st1",
    cx: 318.3,
    cy: 192.8,
    rx: 16.6,
    ry: 16.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.2,259c7.1,0,12.9-5.8,12.9-12.9c0-7.1-5.8-12.9-12.9-12.9c-7.1,0-12.9,5.8-12.9,12.9 C339.3,253.2,345.1,259,352.2,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197,79c0-3.9-3.2-7.1-7.1-7.1c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1C193.9,86.1,197,82.9,197,79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.5,263.1c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1S144.5,263.1,140.5,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205,321.1c-5,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2c5,0,9.2-4.1,9.2-9.2S210.1,321.1,205,321.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.497630e-02 2.497630e-02 0.9997 -4.8141 9.1402)",
    className: "st1",
    cx: 363.5,
    cy: 197.3,
    rx: 7.1,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,155c3.9,0,7.1-3.2,7.1-7.1s-3.2-7.1-7.1-7.1s-7.1,3.2-7.1,7.1S353.8,155,357.7,155z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIeRatioLogo);
export default __webpack_public_path__ + "static/media/ieRatioLogo.d4ef859d7ebd491070066e319d78c0d0.svg";
export { ForwardRef as ReactComponent };